var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgManual(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "#40AFED",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.144 2.144A2.625 2.625 0 016 1.375h8c.166 0 .325.066.442.183l6 6a.625.625 0 01.183.442v12A2.625 2.625 0 0118 22.625H6A2.625 2.625 0 013.375 20V4c0-.696.277-1.364.769-1.856zM6 2.625A1.375 1.375 0 004.625 4v16A1.375 1.375 0 006 21.375h12A1.375 1.375 0 0019.375 20V8.259l-5.634-5.634H6z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 17a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 13a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 9a.5.5 0 01.5-.5h2a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM14 1.5a.5.5 0 01.5.5v5.5H20a.5.5 0 010 1h-6a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5z"
  })));
}
export default SvgManual;